import { Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { CloseSessionModalComponent } from './close-session-modal.component'

@Injectable({
  providedIn: 'root',
})
export class CloseSessionModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  /**
   * Show confirmation dialog for closing a session with pending review items
   *
   * @param sessionId The ID of the session being closed
   * @param hasReviewItems Whether the session has items requiring review
   * @returns Promise resolving to true if user confirms, false otherwise
   */
  confirm(sessionId: string, hasReviewItems: boolean): Promise<boolean> {
    const compKey = 'close-session-modal'
    const uniqueId = compKey + '-' + Date.now()

    const modalRef = this.modalService.open(CloseSessionModalComponent, {
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
      windowClass: uniqueId,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    })

    const component = modalRef.componentInstance as CloseSessionModalComponent
    component.sessionId = sessionId
    component.hasReviewItems = hasReviewItems

    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)

    return modalRef.result.then(
      result => !!result,
      () => false,
    )
  }
}
